/**
 * Created by lari on 27/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('consultexamlist', {
      restrict: 'E',
      bindings: {
        examinations: '='
      },
      templateUrl: 'vcexam/consultexamlist-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Rlog',
        function ($log, Rlog) {
          var vm = this;
          vm.deleteExam = deleteExam;
          vm.showeditor = showeditor;
          vm.showview = showview;

          function showeditor (open, edit) {
            return ((open === true && (angular.isUndefined(edit) || edit === true)) ||
              (open === false && edit === true));
          }


          function showview (open, edit) {
            return ((open === true && edit === false) ||
              (open === false && (edit === false || angular.isUndefined(edit))));
          }


          function deleteExam (exam) {
            exam.active = false;
            exam.open = false;
            exam.$save().$then(function (){}, function (err) {
              $log.error('Exam delete failed for exam: ', exam._id, err);
              Rlog.debug('exam', 'currentexams', 'exam delete save failed', {examid: exam._id});
            });
          }


        }] // controller
    }); // component

// klammerfriedhof
}());